import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/vinh/actions-runner-bikebikebike/_work/bikebikebike/bikebikebike/frontend/node_modules/next/dist/client/app-dir/link.js");
